/* eslint react/prop-types: 0 */

import React from 'react';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';

const FooterImageLinkItem = ({
  ariaLabel, link, description, image, alt, width, newTab,
}) => (
  <a
    aria-label={ariaLabel}
    className="footer-sponsor-link"
    data-cy="footer-link"
    href={link}
    rel="noopener noreferrer"
    target={newTab === true ? '_blank' : '_self'}
  >
    <GatsbyImage
      alt={description || alt}
      className="d-inline-block"
      data-cy="gatsby-img"
      image={getImage(image)}
      style={{ maxWidth: width || 125 }}
      // Don't crop logo images
      imgStyle={{ objectFit: 'contain' }}
    />
  </a>
);

export default FooterImageLinkItem;
